<fa-icon
  [icon]="baseIcon()"
  [class.flipX]="rotationClass() === 'flipX'"
  [class.flipY]="rotationClass() === 'flipY'"
  [class.clockWise]="rotationClass() === 'clockWise'"
  [class.counterClockWise]="rotationClass() === 'counterClockWise'"
  [size]="iconSize()"
></fa-icon>
